import * as v from 'valibot';
import { dateStringSchema, integerInRange } from '../util/valibot';
import { CommonTypeSchema } from './CommonType';
export const entityStateEventSchema = v.object({
    entity_id: integerInRange(0, 0xffffffff),
    ts: dateStringSchema,
    type: CommonTypeSchema,
    value: v.unknown()
});
